import React, { createContext, useContext, useState, useEffect } from 'react';

export const CarritoContext = createContext();

export const useCarrito = () => {
  const context = useContext(CarritoContext);
  return context || { carrito: [], setCarrito: () => {}, agregarItem: () => {} };
};

export const CarritoProvider = ({ children }) => {
  const [carrito, setCarrito] = useState([]);

  useEffect(() => {
    try {
      const carritoLocal = JSON.parse(localStorage.getItem('carrito')) || [];
      setCarrito(carritoLocal);
    } catch (e) {
      console.warn('Error reading carrito from localStorage:', e);
    }
  }, []);

  const agregarItem = (item) => {
    setCarrito((prevCarrito) => {
      const itemExistente = prevCarrito.find(cartItem => cartItem.id === item.id && cartItem.tipo === item.tipo);
      let nuevoCarrito;
      if (itemExistente) {
        nuevoCarrito = prevCarrito.map(cartItem =>
          cartItem.id === item.id && cartItem.tipo === item.tipo ? { ...cartItem, cantidad: cartItem.cantidad + item.cantidad } : cartItem
        );
      } else {
        nuevoCarrito = [...prevCarrito, item];
      }
      try {
        localStorage.setItem('carrito', JSON.stringify(nuevoCarrito));
      } catch (e) {
        console.warn('Error saving carrito to localStorage:', e);
      }
      return nuevoCarrito;
    });
  };

  return (
    <CarritoContext.Provider value={{ carrito, setCarrito, agregarItem }}>
      {children}
    </CarritoContext.Provider>
  );
};
